import { defineAsyncComponent } from 'vue'
import axios from 'axios'
export default{
    components:{
        skeletSliderAndImg: defineAsyncComponent(() =>
            import('@/components/skeletonComponent/skeletSliderAndImg.vue')
        ),
        skeletOffices: defineAsyncComponent(() =>
            import('@/components/skeletonComponent/skeletOffices.vue')
        ),
        skeletInformation: defineAsyncComponent(() =>
            import('@/components/skeletonComponent/skeletInformation.vue')
        ),        
        skeletRecord: defineAsyncComponent(() =>
            import('@/components/skeletonComponent/skeletRecord.vue')
        ),        
        skeletNews: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletNews.vue')
        ),
        skeletLinks: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletLinks.vue')
        ),
        skeletMainDostor:defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletMainDostor.vue')
        ),
        skeletHTML: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletHTML.vue')
        ),
        skeletLinksItem: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletLinksItem.vue')
        ),
        skeletDeputiesAndManagers: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletDeputiesAndManagers.vue')
        ),
        skeletComments: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletComments.vue')
        ),
        skeletGosService: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletGosService.vue')
        ),
        skeletMinzdrav: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletMinzdrav.vue')
        ),
        skeletOfficesPanels: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletOfficesPanels.vue')
        ),
        skeleVacancies: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeleVacancies.vue')
        ),
        
    },
    methods:{
        getSkeleton(path){
            axios
                .get('https://mosp51.ru/api/skeleton?path='+path)
                .then(response=>{
                    this.skeleton = response.data
                })
        }, 
    },
    data(){
        return{
            skeleton:[],
        }
    }

}
